import { Input , HintModalButton} from "components";

type StockAnalysisProps = { label: string; value: string | number; textError?: boolean; withInputField?: boolean; hint?:string };

export const StockAnalysis = ({ label, value, textError, withInputField, hint }: StockAnalysisProps) => {

    return (
        <div className="flex mt-2">
            <div className={`w-[200px] ${withInputField ? "pt-[28px]" : ""}`}>
                <div className="text-right">
                    {label} 
                </div>
                <hr />
            </div>
            <div className="ml-5 w-[500px]">
                {withInputField 
                    ? <Input className="w-[150px] lg:w-full" />
                    : <>
                    <div className={textError ? "text-error" : ""}><b>{value}</b> 
                        {hint && (
                            <HintModalButton title={label} className="ml-3">
                                {hint}
                            </HintModalButton> 
                        )}
                    </div> <hr />
                    </>
                }
            </div>
            
        </div>
    )
}